import { useEffect, useState } from 'react'
import {
  CONFIG_LOCALE_CHANGED_EVENT,
  getActiveConfigLocale,
} from '../utils/config-localization'

/**
 * Locale attivo per label di configurazione form (aggiornato al cambio lingua).
 * @returns {string}
 */
export function useConfigLocale() {
  const [locale, setLocale] = useState(getActiveConfigLocale)

  useEffect(() => {
    const onChange = (event) => {
      setLocale(event.detail?.locale ?? getActiveConfigLocale())
    }
    window.addEventListener(CONFIG_LOCALE_CHANGED_EVENT, onChange)
    return () => window.removeEventListener(CONFIG_LOCALE_CHANGED_EVENT, onChange)
  }, [])

  return locale
}
